import { useState, useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import TrackVisibility from "react-on-screen";

export const CareerTimeline = () => {
  const [visibleItems, setVisibleItems] = useState(new Set());
  const timelineRef = useRef(null);

  // Timeline data with actual career milestones
  const timelineData = [
    {
      id: 1,
      date: "2025 July - Present",
      title: "Associate Software Engineer",
      company: "Fonix Edu Pvt Ltd (Atlas Axilla Group)",
      description:
        "Developed key frontend features for the digital education platform using React.js. Integrated REST APIs and implemented OpenAI models for intelligent content processing. Fine-tuned Hugging Face models using Python for accurate handwritten text detection.",
      icon: "💼",
      type: "work",
    },
    {
      id: 2,
      date: "2025 Feb - 2025 July",
      title: "Associate Software Engineer",
      company: "Fonix Software Solution",
      description:
        "Developed admin panels and dashboards for Coach Donee, Korean Master, and Rotary using React.js and TypeScript. Built LMS backend using Python with OpenAI, Hugging Face, and Groq AI. Developed Grading System integrating Google OCR, TestReacted OCR, Claude AI, and OpenAI.",
      icon: "🚀",
      type: "work",
    },
    {
      id: 3,
      date: "2024 Feb - 2025 Feb",
      title: "Software Engineer Intern",
      company: "Fonix Software Solution",
      description:
        "Developed frontend landing pages and admin/client UIs using React.js. Created backend APIs and mobile routes with Node.js and Express.js. Implemented authentication, route protection, and integrated PayHere & Direct Pay gateways. Integrated WebSocket for real-time multiplayer features in ExamHub.",
      icon: "💻",
      type: "work",
    },
    {
      id: 4,
      date: "2022 - Present",
      title: "BSc (Hons) in Information Technology",
      company: "Sri Lanka Institute of Information Technology",
      description:
        "Specializing in Information Technology with focus on software engineering, web development, and modern programming paradigms.",
      icon: "🎓",
      type: "education",
    },
    {
      id: 5,
      date: "2018 - 2020",
      title: "G.C.E Advanced Level",
      company: "St Aloysius College Rathnapura",
      description:
        "Completed G.C.E Advanced Level 2020 with Physical Science stream (C3). Built strong foundation in mathematics and scientific principles.",
      icon: "📚",
      type: "education",
    },
  ];

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const itemId = parseInt(entry.target.dataset.itemId);
          setVisibleItems((prev) => new Set([...prev, itemId]));
        }
      });
    };

    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions
    );

    const timelineItems = document.querySelectorAll(".timeline-item");
    timelineItems.forEach((item) => observer.observe(item));

    return () => {
      timelineItems.forEach((item) => observer.unobserve(item));
    };
  }, []);

  const handleItemClick = (item) => {
    // Customize this based on your needs:
    // - Navigate to projects section
    // - Open a modal with more details
    // - Open external links
    console.log("Timeline item clicked:", item);
  };

  return (
    <section className="career-timeline" id="timeline">
      <Container>
        <div className="timeline-header">
          <h2>
            My <span className="gradient-text">Career Journey</span>
          </h2>
          <p className="timeline-subtitle">
            A timeline of my professional growth, achievements, and milestones
          </p>
        </div>

        <div className="timeline-container" ref={timelineRef}>
          <div className="timeline-line"></div>

          {timelineData.map((item, index) => (
            <div
              key={item.id}
              className={`timeline-item ${index % 2 === 0 ? "timeline-item-left" : "timeline-item-right"
                } ${visibleItems.has(item.id) ? "visible" : ""}`}
              data-item-id={item.id}
              onClick={() => handleItemClick(item)}
            >
              <div className="timeline-content">
                <div className="timeline-date">{item.date}</div>
                <h3 className="timeline-title">{item.title}</h3>
                <h4 className="timeline-company">{item.company}</h4>
                <p className="timeline-description">{item.description}</p>
                <div className={`timeline-badge ${item.type}`}>
                  {item.type === "work" && "Work Experience"}
                  {item.type === "education" && "Education"}
                  {item.type === "achievement" && "Achievement"}
                </div>
              </div>

              <div className="timeline-icon-wrapper">
                <div className="timeline-icon">
                  <span className="icon-emoji">{item.icon}</span>
                </div>
                <div className="timeline-dot"></div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};
